import { Switch, Route } from 'react-router-dom';
import AuthPage from './auth/AuthPage';
import ProtectedRoute from './ProtectedRoute.component';
import PublicRoute from './PublicRoute.component';
import BasePricePage from '../pages/BasePricePage.component';
import ComponentListPage from '../pages/ComponentListPage.component';
import ComponentViewPage from '../pages/ComponentViewPage.component';
import HomePage from '../pages/HomePage.component';
import NotFound from '../pages/NotFound.component';
import PanelCreatePage from '../pages/PanelCreatePage.component';
import PanelListPage from '../pages/PanelListPage.component';
import PanelViewPage from '../pages/PanelViewPage.component';
import UserViewPage from '../pages/UserViewPage.component';

function Routes() {
  return (
    <Switch>
      <Route exact path="/">
        <HomePage />
      </Route>

      {/* Auth routes - protected from authenticated users */}
      <PublicRoute path="/login" component={AuthPage} />
      <PublicRoute path="/forgot-password" component={AuthPage} />
      <PublicRoute path="/reset-password" component={AuthPage} />
      <PublicRoute path="/verify-email" component={AuthPage} />
      <PublicRoute path="/accept-invitation" component={AuthPage} />

      <ProtectedRoute path="/panels/new" component={PanelCreatePage} />

      <ProtectedRoute path="/panels/page/:page" component={PanelListPage} />

      <ProtectedRoute path="/panels/:id" component={PanelViewPage} />

      <ProtectedRoute path="/panels" component={PanelListPage} />

      <ProtectedRoute path="/members/:page" component={UserViewPage} />

      <ProtectedRoute path="/members" component={UserViewPage} />

      <ProtectedRoute path="/components/page/:page" component={ComponentListPage} />

      <ProtectedRoute path="/components/:id" component={ComponentViewPage} />

      <ProtectedRoute path="/components" component={ComponentListPage} />

      <ProtectedRoute path="/base_prices" component={BasePricePage} />
      <Route path="*">
        <NotFound />
      </Route>
    </Switch>
  );
}

export default Routes;